'use strict';

var d3 = require('d3');
var _ = require('lodash');
var ChartLengthOfStay = function ChartLengthOfStay(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartXAxis, chartYAxis, chartConstants, chartFilterBars, svgPatternService, chartScales) {
  var chartParams = require('./Params');
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractChart.call(this, container);
    svgPatternService.initPatterns(['user-exclusion', 'user-exclusion-viewport']);
    var dispatch = d3.dispatch('rangechange', 'rangechangeend', 'maxvisiblerangechange', 'render', 'selectedLengthOfStay');
    d3.rebind(this, dispatch, 'on');
    var groups = chartGroups('lengthOfStay', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var filterBars = chartFilterBars(['m1', 'm2'], 'lengthOfStay');
    var tiles = chartTiles('lengthOfStay', 'm2', 'tiles').withHeight(2);
    var circles = chartCircles('circles');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine();
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    yAxisLeft.label('Total Fares');
    xAxis.label('# of Days');
    var maxRangeSize;
    this.render = function (data, range) {
      this.initChart(data, this.getMaxRange(range), chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.setMaxRangeSize();
      this.callForDataGroup([yAxisLeft, groups, m1Bars, m2Bars, filterBars, tiles, circles, xAxis], this.scales);
      dispatch.render();
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.setMaxRangeSize = function () {
      var maxWidth = 35 / 0.9; //group (bar + padding) width, refers to Scales.js:24
      var chartWidth = chartParams(this.container.width()).width;
      var newMaxRangeSize = Math.floor(chartWidth / maxWidth);
      if (newMaxRangeSize !== maxRangeSize) {
        maxRangeSize = newMaxRangeSize;
        dispatch.maxvisiblerangechange(newMaxRangeSize);
      }
    };
    this.getMaxRange = function (range) {
      if (typeof range === 'undefined') {
        return range;
      }
      this.setMaxRangeSize();
      var delta = range[1] - range[0];
      if (delta > maxRangeSize) {
        range[1] = range[0] + maxRangeSize;
      }
      return range;
    };
    this.getMaxRangeSize = function () {
      return maxRangeSize;
    };
    this.setFilterBars = function (selectedBars) {
      filterBars.withSelection(selectedBars);
      this.callForDataGroup([filterBars], this.scales);
    };
    groups.on('groupclick', function (d, i) {
      _.each(self.data, function (d, idx) {
        if (i !== idx) {
          d.selected = false;
        } else {
          d.selected = true;
        }
      });
      self.callForDataGroup([groups], self.scales);
      dispatch.selectedLengthOfStay(d, i);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartLengthOfStay.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartLengthOfStayFilterBars', 'SvgPatternService', 'ChartLengthOfStayScale'];
module.exports = ChartLengthOfStay;